<template>
  <div>
    <div class="frameitem open">
      <img src="@/assets/img/supplier_1.png" />
    </div>
    <div
      class="frameitem"
      style="color:#fff"
      v-for="(item, index) in framelist"
      @click="goto(item)"
      :key="index"
    >
      <img :src="item.on_icon[item.on_icon.length-1]?item.on_icon[item.on_icon.length-1].path:null" />
      <div class="hover-text">{{ item.service_name }}</div>
    </div>
    <div v-if="framemore.length>0" class="frameitem more" style="color:#fff">
      <i class="el-icon-caret-right"></i>
      <div class="hover-div">
        <div class="more-item" v-for="(item, index) in framemore" @click="goto(item)" :key="index">
          <img :title="item.service_name" :src="item.on_icon[item.on_icon.length-1]?item.on_icon[item.on_icon.length-1].path:null" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      framelist: [],
      framemore: []
    };
  },
  created() {
    this.getdata();
  },
  methods: {
    goto(item) {
      let mode;
      item.service_url.map((val, i) => {
        if (val.type == "back") {
          mode = "back";
        }
      });

      item.service_url.find(val => {
        return val.type == "back";
      });
      if (
        item.service_url.find(val => {
          return val.type == "back";
        }) != "undefined"
      ) {
        this.$func.getsasstoken().then(res => {
          let tempPage = window.open("", " _blank");

          tempPage.location =
            item.service_url
              .find(val => {
                return val.type == "back";
              })
              .url.indexOf("?") > 0
              ? item.service_url.find(val => {
                  return val.type == "back";
                }).url +
                "&token=" +
                res.data.server_response.once_token
              : item.service_url.find(val => {
                  return val.type == "back";
                }).url +
                "?token=" +
                res.data.server_response.once_token;
        });
      } else {
        this.$func.getsasstoken().then(res => {
          let tempPage = window.open("", " _blank");
          tempPage.location =
            item.service_url
              .find(val => {
                return val.type == "home";
              })
              .url.indexOf("?") > 0
              ? item.service_url.find(val => {
                  return val.type == "home";
                }).url +
                "&token=" +
                res.data.server_response.once_token
              : item.service_url.find(home => {
                  return val.type == "back";
                }).url +
                "?token=" +
                res.data.server_response.once_token;
        });
      }
    },
    getdata() {
      let url = `/api/supplier/get/open/services`;
      this.$http.get(url).then(res => {
        if (res.res_data.details.length > 5) {
          this.framelist = res.res_data.details.slice(0, 5);
          this.framemore = res.res_data.details.slice(5);
        } else {
          this.framelist = res.res_data.details;
        }
        // this.framelist = res.res_data.details;
      });
    }
  }
};
</script>
<style lang="less" scope>
.frameitem {
  width: 60px;
  height: 52px;
  position: relative;
  cursor: pointer;
  &.open {
    background: rgba(35, 44, 57, 1);
  }
  &:hover {
    background: rgba(35, 44, 57, 1);
    .hover-text {
      z-index: 20;
      opacity: 1;
    }
    .hover-div {
      z-index: 20;
      opacity: 1;
    }
  }
  img {
    position: absolute;
    width: 32px;
    height: 32px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  i {
    position: absolute;
    width: 32px;
    height: 32px;

    font-size: 32px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
.hover-div {
  cursor: default;
  z-index: -1;
  opacity: 0;
  background: rgba(35, 44, 57, 1);
  min-height: 52px;
  min-width: 240px;
  position: absolute;
  top: 0%;
  left: 60px;
  .more-item{
    cursor: pointer;
    position: relative;
    margin: 6px 10px ;
    float: left;
    height: 40px;
    width: 40px;
    &:hover{
      background: hsla(0,0%,100%,.15);
    }
    img {
    position: absolute;
    width: 32px;
    height: 32px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  }
}
.hover-text {
  position: absolute;
  top: 50%;
  left: calc(~" 60px + 12px");
  transform: translateY(-50%);
  background: rgba(35, 44, 57, 1);
  border-radius: 3px;
  color: #fff;
  height: 30px;
  line-height: 30px;
  white-space: nowrap;
  padding: 0 10px;
  z-index: -1;
  opacity: 0;
  transition: 0.3s;
  pointer-events: none;

  &:before {
    position: absolute;
    content: "";
    height: 0;
    width: 0;
    border-top: 6px solid transparent;
    border-right: 8px solid rgba(35, 44, 57, 1);
    border-bottom: 6px solid transparent;
    top: 50%;
    right: 100%;
    transform: translateY(-50%);
  }
}
</style>